<template>
    <div>
        <card-component class="mt-3 mb-5">
            <template v-slot:content>
                    <div :id="'menuId'+menu_id">
                    <div class="row">
                        <div class="col-12  col-md-6 d-flex justify-content-center order-0 order-md-0">
                            <h4>{{date | formateGlobalDate}}</h4>
                        </div>
                        <div class="col-12 col-md-6 d-flex justify-content-center order-1 order-md-2">
                            <h4>{{ date | dateWeekName }}</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 hr"></div>
                    </div>

                    <!-- opcoes de prato do dia-->
                    <div class="row justify-content-center mb-3" v-for="(option, key) in optionsLabel" :key="key" >
                        <div class="col-12 col-lg-4 mt-3 card-menu-option" :class="'cla'+menu_id" :id="+menu_id +'_' +key"  v-if="dish(key)[0]" @click="store(menu_id +'_' +key, key)">
                            <div class="row">
                                <div class="col-12 d-flex justify-content-center">
                                    <h4>{{option}}</h4>
                                </div>
                            </div>
                            <div class="hr"></div>
                            <div class="row">
                                <div class="col-12 d-flex justify-content-md-center">
                                    <h6 >{{dish(key)[0]}}</h6>
                                </div>
                            </div>
                            <div class="row" v-if="key===0">
                                <div class="col-12 d-flex justify-content-md-center">
                                    <h6>{{datas['principal2']}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </template>
        </card-component>

    </div>


</template>

<script>

import * as bootstrap from 'bootstrap';
import Swal from 'sweetalert2'

export default {
    name: "OrderCustommerEmployees",

    props: [
        'menu_id', 'date', 'menu_datas', 'order_customer_employees_route', 'confirm_register_data_route',
        'order_customer_employees_find_by_register_route'
    ],

    computed: {
        optionsLabel() {
            return ['Principal','Ovo', 'Prato do Chefe', 'Fit Grill', 'Fit Grill Opc 1', 'Fit Grill Opc 2']
        },

    },

    data() {
        return {
            serviceName: $.cookie('employee_service_name'),
            datas : '',
            isLoading: false,
        }
    },

    methods: {

        dish(key){
            if(key === 0)
               return [this.datas['principal1'], 'principal1']
            else if (key === 1)
                return [this.datas['ovo'], 'ovo']
            else if (key === 2)
                return [this.datas['prato_do_chef'], 'prato_do_chef']
            else if (key === 3)
                return [this.datas['fit_grill'], 'fit_grill']
            else if (key === 4)
                return [this.datas['fit_grill_opcao1'], 'fit_grill_opcao1']
            else if (key === 5)
                return [this.datas['fit_grill_opcao2'], 'fit_grill_opcao2']

        },

        hideCarouselButon() {
            let $this;
            $this = $("#carouselId");
            if ($("#carouselId .carousel-inner .carousel-item:first").hasClass("active")) {
                $(".carousel-control-prev").hide()
                $(".carousel-control-next").show();
            } else if ($("#carouselId .carousel-inner .carousel-item:last").hasClass("active")) {
                $(".carousel-control-prev").show()
                $(".carousel-control-next").hide();
            }else{
                $(".carousel-control-prev").show()
                $(".carousel-control-next").show();
            }

        },

        optChoose(divId){

            //desmarcar todas opcoes
            let mainDivId = document.getElementsByClassName('cla'+this.menu_id);
            Array.prototype.forEach.call(mainDivId, function(el) {
                document.getElementById(el.id).classList.remove('card-menu-option-selected');
                document.getElementById(el.id).classList.add('card-menu-option');
            });

            //marcar opcao escolhida
            let divID = document.getElementById(divId);
            divID.classList.remove('card-menu-option');
            divID.classList.add('card-menu-option-selected');

            //console.log(mainDivId);
        },

        caseUpdateMarkChooseOption(){
            let url =
                this.order_customer_employees_find_by_register_route+'/'+$.cookie('employee_register')+'/'+this.date;

            axios.get(url).then(response => {
                if(response.data){
                   // marcar opcao escolhida
                    let divID = document.getElementById(response.data.div_id);
                    divID.classList.remove('card-menu-option');
                    divID.classList.add('card-menu-option-selected');
                }
            }).catch(error => {
                console.log(error);
            });

        },

        store(divId, key){
            let url = this.order_customer_employees_route;

            console.log(this.datas['expiration_date']);

            let formData = new FormData();
            formData.append('date', this.date);
            formData.append('register', $.cookie('employee_register'));
            formData.append('service_id', $.cookie('employee_service'));
            formData.append('employee',$.cookie('employee_name'));
            formData.append('dish_key',this.dish(key)[1]);
            formData.append('finished','0');
            formData.append('menu_expiration', this.datas['expiration_date']);
            formData.append('div_id', divId);

            if(this.dish(key)[1] === 'principal1'){
                formData.append('dish_chosen', this.datas['principal1'] + ' + ' + this.datas['principal2']);
            }else{
                formData.append('dish_chosen',this.dish(key)[0]);
            }


            this.isLoading = true;

            axios.post(url, formData)
                .then(response => {
                   // console.log(response.data);
                    if(response.data.status === true){
                        this.optChoose(divId);
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Algo deu errado!',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location = this.confirm_register_data_route;
                            }
                        })
                    }
                })
                .catch(error => {
                    console.log(error.response.data);
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Erro ao acessar o servidor!',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location = this.confirm_register_data_route;
                        }
                    })
                });

        }
    },

    mounted() {

        let myCarousel = document.querySelector('#carouselId')
        let carousel = new bootstrap.Carousel(myCarousel, {
            interval: 5000000,
        })


        this.hideCarouselButon();
        $("#carouselId").on("slid.bs.carousel", "", this.hideCarouselButon)

        this.datas = JSON.parse(this.menu_datas);

        //caso o funcionario ja tenha escolhido um prato, marcar a opcao
        this.caseUpdateMarkChooseOption();

    }


}
</script>

<style scoped>

</style>
